// ============================================================================
// SWAHILI BIBLE PASSAGES - Biblia Habari Njema
// ============================================================================
// Vifungu vya Biblia kwa Kiswahili na marejeleo ya Strong

export const biblePassagesSw = {
  "Mwanzo_1": {
    book: "Mwanzo",
    chapter: 1,
    title: "Uumbaji wa ulimwengu",
    verses: [
      { number: 1, text: "Hapo mwanzo Mungu aliumba mbingu na nchi.", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "Nayo nchi ilikuwa ukiwa na utupu, na giza lilikuwa juu ya uso wa kilindi. Roho wa Mungu akarindima juu ya uso wa maji.", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "Mungu akasema: Iwe nuru. Ikawa nuru.", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "Mungu akaiona nuru, ya kuwa ni nzuri. Mungu akatenganisha nuru na giza.", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "Mungu akaiita nuru mchana, na giza akaliita usiku. Ikawa jioni, ikawa asubuhi, siku ya kwanza.", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "Mungu akasema: Iwe anga katikati ya maji, na itenganishe maji na maji.", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "Mungu akafanya anga, na kutenganisha maji yaliyo chini ya anga na maji yaliyo juu ya anga. Ikawa hivyo.", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "Mungu akaliita anga mbingu. Ikawa jioni, ikawa asubuhi, siku ya pili.", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "Mungu akamwumba mtu katika sura yake mwenyewe, katika sura ya Mungu alimwumba; mwanaume na mwanamke aliwaumba.", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "Mungu akaona vyote alivyoviumba, na tazama, vilikuwa vizuri sana. Ikawa jioni, ikawa asubuhi, siku ya sita.", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Zaburi_23": {
    book: "Zaburi",
    chapter: 23,
    title: "Bwana ni mchungaji wangu",
    verses: [
      { number: 1, text: "Bwana ni mchungaji wangu; sitapungukiwa na kitu.", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "Hunilaza katika malisho ya majani mabichi; huniongoza kando ya maji ya utulivu.", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "Huuhuisha roho yangu; huniongoza katika njia za haki kwa ajili ya jina lake.", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "Hata nikienda katika bonde la kivuli cha mauti, sitaogopa mabaya, kwa kuwa wewe u pamoja nami; fimbo yako na mkongojo wako, vitu hivyo vinanipa faraja.", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "Waniandallia meza mbele ya adui zangu; umenipaka kichwa changu mafuta; kikombe changu kinafurika.", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "Hakika wema na rehema zitanifuata siku zote za maisha yangu; nami nitakaa katika nyumba ya Bwana milele.", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Yohana_3": {
    book: "Yohana",
    chapter: 3,
    title: "Yesu na Nikodemo",
    verses: [
      { number: 16, text: "Kwa maana Mungu aliupenda ulimwengu hivi, hata akamtoa Mwanawe pekee, ili kila mtu amwaminiye asipotee, bali awe na uzima wa milele.", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "Kwa sababu Mungu hakumtuma Mwanawe ulimwenguni ili auhukumu ulimwengu, bali ili ulimwengu uokolewee kwa njia yake.", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "Yeye amwaminiye hahukumiwi; yeye asiyeamini amekwisha hukumiwa, kwa sababu hakuamini jina la Mwana wa pekee wa Mungu.", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Wafilipi_4": {
    book: "Wafilipi",
    chapter: 4,
    title: "Amani ya Mungu",
    verses: [
      { number: 4, text: "Furahini katika Bwana sikuzote; tena nasema, furahini!", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "Msijali jambo lo lote, bali katika kila jambo kwa maombi na dua, pamoja na shukrani, mjulishe Mungu mahitaji yenu.", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "Na amani ya Mungu, inayozidi akili zote, italinda mioyo yenu na mawazo yenu katika Kristo Yesu.", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "Naweza kila kitu katika yeye anayenipa nguvu.", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesSw;
